export default __webpack_public_path__ + "static/media/Aeonik-BoldItalic.d96e229c.woff";